import { helper as buildHelper } from '@ember/component/helper';

export function formatClassname(params) 
{
	let className = params[0];
	
	if(className != undefined)
		return className.split('*')[0];
	return "";
}

export default buildHelper(formatClassname);